import { defineMessages } from 'react-intl'

const messages = {
  decline: {
    id: 'app.components.product-decline-button.decline',
    defaultMessage: 'Decline',
  },
  tooltip: {
    id: 'app.components.product-decline-button.tooltip',
    defaultMessage: 'In order to Decline, you need to Unpack first',
  },
}

export default defineMessages(messages)
